import type { QuickReply } from '../../types/agent';
import { useChatStore } from '../../store/chat';

/**
 * Botões de resposta rápida no estilo NATIVO do WhatsApp (interactive reply buttons):
 * bolhas brancas separadas, texto teal centralizado, ocupando a largura da mensagem.
 * Tocar envia o `value` como se o usuário tivesse digitado.
 */
export function QuickReplies({ replies }: { replies: QuickReply[] }) {
  const streaming = useChatStore((s) => s.connectionState === 'streaming');
  if (!replies.length) return null;
  return (
    <div className="flex flex-col gap-[3px] mt-[3px] max-w-[85%] md:max-w-[65%] wa-bubble-enter">
      {replies.map((r) => (
        <button
          key={r.label}
          type="button"
          disabled={streaming}
          onClick={() => useChatStore.getState().sendMessage(r.value)}
          className="w-full bg-white rounded-[18px] shadow-[0_1px_1px_rgba(0,0,0,0.05)] px-3 py-[10px] text-[15px] md:text-[14px] font-medium text-[#1DAB61] text-center leading-tight active:bg-[#F5F6F6] transition-colors disabled:opacity-50"
        >
          {r.label}
        </button>
      ))}
    </div>
  );
}
